<template>
  <div>
    <v-row dense>
      <v-col cols="6" md="3">
        <v-btn
          color="primary"
          block
          :outlined="activeTab != 'renting'"
          @click="changeTab('renting')"
        >
          Sắp đến hạn
          <span class="orange--text">
            ({{ (counts.renting && counts.renting.count_id) || 0 }})
          </span>
        </v-btn>
      </v-col>
      <v-col cols="6" md="3">
        <v-btn
          color="primary"
          block
          :outlined="activeTab != 'overdue'"
          @click="changeTab('overdue')"
        >
          Quá hạn
          <span class="orange--text">
            ({{ (counts.overdue && counts.overdue.count_id) || 0 }})
          </span>
        </v-btn>
      </v-col>
    </v-row>
    <div>
      <v-simple-table class="table-padding-2 table-h-36 mt-3">
        <template v-slot:default>
          <thead class="v-data-table-header">
            <tr>
              <th role="columnheader" class="text-center">Tracking</th>
              <th role="columnheader" class="text-center">Xe</th>
              <th role="columnheader" class="text-center">Hạn trả</th>
              <th role="columnheader" class="text-center">Khách hàng</th>
              <th role="columnheader" class="text-center">Kênh liên lạc</th>
              <th role="columnheader" class="text-center" style="width: 75px">
                TT. Liên lạc
              </th>
              <th
                role="columnheader"
                class="text-center"
                style="width: 75px"
              ></th>
            </tr>
          </thead>
          <tbody
            v-for="(item, index) in items"
            :key="`r_${index}_${item.id}`"
            :style="index % 2 == 0 ? 'background-color: #ddd' : ''"
          >
            <tr class="text-center">
              <td>
                <span
                  class="primary--text cursor-pointer text-decoration-underline"
                  @click="showOrderDialog(item)"
                >
                  {{ item.tracking_id }}
                </span>
              </td>
              <td>{{ item.asset_uid_name }}</td>
              <td>
                {{ formatDateTime(item.end_time) }}
              </td>
              <td>{{ item.customer_name }}</td>
              <td>{{ item.contact_channel_name }}</td>
              <td>
                <QrLink :value="item.customer_contact_name" />
              </td>
              <td>
                <v-btn x-small color="success" @click="showRenewalDialog(item)">
                  Gia hạn
                </v-btn>
                <!-- <v-btn
                  x-small
                  color="error"
                  class="ml-1"
                  @click="showReturnDialog(item, 'return')"
                >
                  Trả xe
                </v-btn> -->
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>

    <v-dialog v-model="dialogOrder" max-width="420px">
      <DetailDialog
        v-if="dialogOrder"
        :order="order"
        :is-show-exchange="false"
        @close="hideOrderDialog"
      />
    </v-dialog>

    <v-dialog v-model="dialogReturn" persistent max-width="420px">
      <CreateReturnRequest
        v-if="dialogReturn"
        :order="order"
        @close="hideReturnDialog"
      />
    </v-dialog>

    <v-dialog v-model="dialogRenewal" persistent max-width="420px">
      <CreateRenewal
        v-if="dialogRenewal"
        :selected="order"
        :is-branch="false"
        @close="hideRenewalDialog"
      />
    </v-dialog>
  </div>
</template>

<script>
import { httpClient } from "@/libs/http";

export default {
  name: "RenewalPartner",
  components: {
    QrLink: () => import("@/components/common/QrLink"),
    DetailDialog: () => import("@/components/exchange/DetailDialog"),
    CreateReturnRequest: () => import("@/components/rent/CreateReturnRequest"),
    CreateRenewal: () => import("@/components/rent/CreateRenewal"),
  },
  data: () => ({
    items: [],
    waitEndItems: [],
    code: null,
    order: {},
    isLoading: false,
    dialogOrder: false,
    dialogReturn: false,
    dialogRenewal: false,
    dialogPayment: false,
    activeTab: "renting",
    counts: {},
  }),
  mounted() {
    this.getList();
    this.getCount();
  },
  methods: {
    changeTab(tab) {
      this.activeTab = tab;
      this.getList();
    },
    async getDetail({ id_order }) {
      const { data } = await httpClient.post("/order/v1/get-detail", {
        id_order,
      });
      this.order = { ...data };
    },

    async showRenewalDialog(item) {
      this.order = { ...item };
      this.dialogRenewal = true;
    },

    hideRenewalDialog() {
      this.order = {};
      this.dialogRenewal = false;
      this.getList();
    },

    async showReturnDialog(item, type) {
      this.returnType = type;
      await this.getDetail({ id_order: item.id });
      this.dialogReturn = true;
    },

    hideReturnDialog() {
      this.order = {};
      this.dialogReturn = false;
      this.getList();
    },

    async showOrderDialog(item) {
      await this.getDetail({ id_order: item.id });
      this.dialogOrder = true;
    },

    hideOrderDialog() {
      this.order = {};
      this.dialogOrder = false;
    },

    async getCount() {
      const { data } = await httpClient.post(
        "/order/v1/partner-get-wait-renewal-count"
      );
      this.counts = { ...data };
    },

    async getList() {
      const { data } = await httpClient.post(
        "/order/v1/partner-get-wait-renewal",
        {
          type: this.activeTab,
        }
      );
      this.items = [...data];
    },
  },
};
</script>
